import { hexToRgbArray } from '../utils/color';
import { fabricToPdfCoords } from '../utils/coordinateUtils';

/**
 * Convert Fabric Line to PDF Ink annotation
 */
export function fabricLineToPdfInk({
  page,
  fabricObject,
  basePageDimensions: { width, height },
  user_full_name,
}) {
  const { x1, y1, x2, y2, strokeWidth, stroke } = fabricObject;

  const start = fabricToPdfCoords({
    x1,
    y1,
    x2: x1,
    y2: y1,
    page,
    width,
    height,
  });

  const end = fabricToPdfCoords({
    x1: x2,
    y1: y2,
    x2,
    y2,
    page,
    width,
    height,
  });

  const pathPoints = [start.x1, start.y1, end.x1, end.y1];

  page.node.addAnnot(
    page.doc.context.obj({
      Type: 'Annot',
      Subtype: 'Ink',
      Rect: fabricToPdfCoords({
        x1: Math.min(x1, x2),
        y1: Math.min(y1, y2),
        x2: Math.max(x1, x2),
        y2: Math.max(y1, y2),
        page,
        width,
        height,
      }).rect,
      InkList: [pathPoints],
      Border: [0, 0, strokeWidth],
      C: hexToRgbArray(stroke),
      T: user_full_name,
    })
  );
}

// import { hexToRgbArray } from '../utils/color';
// import { fabricToPdfCoords } from '../utils/coordinateUtils';

// export function fabricLineToPdfInk({
//   page,
//   fabricObject,
//   basePageDimensions: { width, height },
//   user_full_name,
// }) {
//   const { x1, y1, x2, y2, strokeWidth } = fabricObject;

//   const pdfCoords = fabricToPdfCoords({
//     x1,
//     y1,
//     x2,
//     y2,
//     page,
//     width,
//     height,
//   });

//   page.node.addAnnot(
//     page.doc.context.obj({
//       Type: 'Annot',
//       Subtype: 'Line',

//       Rect: pdfCoords.rect,
//       L: [pdfCoords.x1, pdfCoords.y1, pdfCoords.x2, pdfCoords.y2],

//       C: hexToRgbArray(stroke),
//       BS: { W: strokeWidth },

//       T: user_full_name,
//       //   F: 4,
//     })
//   );
// }
